export default {
  namespaced: true,
  state: {
    subscribeForm: null,
  },
  getters: {
    subscribeForm(state) {
      return state.subscribeForm
    },
  },
  mutations: {
    setSubscribeForm(state, value) {
      state.subscribeForm = value
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/form.js